// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gOs-yQk0TLYuc47Q3QyDt","item":"_1b6o7CD3O7ir5lqsLq3z6-","text":"_2FqUwja_D4D8S3Ne_37nvp","hashtag":"_1ZPQRvAts16C8_EfD7Xmao"};